import React                    from 'react';
import { DrawTriggerOptions }   from '@tokamap/core';
import SliderInputNumberFeature from '@/TokamapEditor/ux/AreaSidebar/SliderInputNumberFeature';
import { MapViewState }         from '@tokamap/core';

export default function SliderInputNumberFeatureStyle({
	property,
	initialValue,
	toModelValue,
	fromModelValue,
	inputProps,
	isPercent,
	mixed,
	apply,
	unitSelect,
}: {
	property: 'borderWidth' | 'zoom' | 'zoomMin' | 'zoomMax';
	initialValue: number;
	toModelValue: (v: number) => number;
	fromModelValue: (v: number) => number;
	inputProps?: any;
	isPercent?: boolean;
	mixed?: boolean;
	apply: <TName extends keyof (MapViewState)>(name: TName, value: any, options?: DrawTriggerOptions) => Promise<void>;
	unitSelect?: React.ComponentProps<typeof SliderInputNumberFeature>['unitSelect'];
}) {
	const startValue = React.useRef(initialValue);
	const [loading, setLoading] = React.useState(false);

	return (
		<SliderInputNumberFeature
			loading={loading}
			value={fromModelValue(initialValue)}
			isPercent={isPercent}
			mixed={mixed}
			inputProps={inputProps}
			unitSelect={unitSelect}
			onStartChange={() => {
				startValue.current = initialValue;
			}}
			onChange={v => {
				return apply(property as never, toModelValue(v), {
					skipSave: true,
					skipHistory: true,
					skipConfirm: true,
				});
			}}
			onAfterChange={async v => {
				setLoading(true);
				await apply(property as never, toModelValue(v));
				setLoading(false);
			}}
		/>
	);
}